export const appHead = {"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"name":"og:description","content":"Praticamos o bem e a caridade através da nossa querida Umbanda!"},{"name":"twitter:description","content":"Praticamos o bem e a caridade através da nossa querida Umbanda!"},{"name":"twitter:image","content":"https://assets.terreirovoritadasalmas.com.br/illustrations/hero-welcome.jpg"},{"name":"og:type","content":"website"},{"name":"og:image","content":"https://assets.terreirovoritadasalmas.com.br/illustrations/hero-welcome.jpg"},{"name":"og:site_name","content":"Terreiro de Umbanda Vó Rita das Almas"},{"name":"og:locale","content":"pt_BR"},{"name":"keywords","content":"terreiro, umbanda, almas, espiritualidade, espiritismo, psicografia, cartas consoladoras, atendimento, pretos velhos, preto velho, orixá"}],"link":[{"rel":"icon","type":"image/x-icon","href":"https://assets.terreirovoritadasalmas.com.br/favicons/favicon.ico"}],"style":[],"script":[],"noscript":[],"title":"Terreiro de Umbanda Vó Rita das Almas","titleTemplate":"%s | Terreiro de Umbanda Vó Rita das Almas","htmlAttrs":{"lang":"br"}}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = true

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true